import PropTypes from "prop-types";
import { Box, Card, Divider, Typography } from "@mui/material";
import React from "react";

const CardHeader = ({ header, children, icon, marginX, rightComponent, filter, ...props }) => {
  return (
    <Card
      sx={{
        borderRadius: 1, 
        boxShadow: "0px 4px 12px 4px #E9E9E980",
        padding: "16px",
        border: "1px solid #FFFFFF",
        margin: '15px 0', 
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Box display="flex" alignItems="center">
          {icon && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                mr: 1,
              }}
            >
              {icon}
            </Box>
          )}
          <Typography variant="h6" component="div">
            {header}
          </Typography>
        </Box>
        {rightComponent && (
          <Box display="flex" alignItems="center">
            {rightComponent}
          </Box>
        )}
      </Box>
      {filter && (
        <Box mb={2}>
          {filter}
        </Box>
      )}
      <Divider sx={{ my: '15px', mx: marginX ? marginX : '0' }} />
      {children}
    </Card>
  );
};

CardHeader.propTypes = {
  header: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  icon: PropTypes.element,
  marginX: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  rightComponent: PropTypes.node,
  filter: PropTypes.node,
};

export default CardHeader;
